// `app-container-ui` (pulled in via `platform-common-service`, which the
// platform i18n bridge uses) expects the T3 `Box` namespace as a browser
// global. In the platform shell it is provided by the host page; this app is
// standalone, and t3js only exports `Box` under CommonJS, so expose it here.
// Must be imported before any module that loads `platform-common-service`.
import Box from 't3js';

window.Box = window.Box || Box;
